import { render, staticRenderFns } from "./KpiJobStaffComponent.vue?vue&type=template&id=6c4e04b6"
import script from "./KpiJobStaffComponent.vue?vue&type=script&lang=js"
export * from "./KpiJobStaffComponent.vue?vue&type=script&lang=js"
import style0 from "./KpiJobStaffComponent.vue?vue&type=style&index=0&id=6c4e04b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports